import type { HTMLAttributes } from 'react'

/**
 * Matches Stitch's `.glass-panel` / `.glass-level-1` treatment: translucent
 * white fill, blur, and a bright top/left edge with a dim bottom/right edge
 * so the border reads as a light source rather than a flat outline.
 */
export function GlassCard({
  className = '',
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={
        'rounded-lg bg-white/[0.04] backdrop-blur-glass ' +
        'border-t border-l border-white/[0.15] border-b border-r border-white/[0.05] ' +
        className
      }
      {...props}
    />
  )
}
